import { FC } from 'react'
import { Row, Col, Text, Content, Image } from '@/client/components'
import { useRouterPush } from '@/client/hooks'
import * as S from './styles'
import { FinishingListProps } from '../types'

export const FinishingList: FC<FinishingListProps> = ({ finishing_touches }) => {
  const { routerPush } = useRouterPush()
  return (
    <>
      {finishing_touches?.map(({ title, description, image, label_button, link }, index) => (
        <S.Finishing key={title}>
          <Row>
            <Col xs={12}>
              <S.ContentInfos>
                <S.ContentLeft>
                  <Text family='heading' size='lg' weight='bold' margin='0 0 2rem'>
                    {title}
                  </Text>
                  <Content content={description} />
                  {label_button && <S.Button href={link}>{label_button}</S.Button>}
                </S.ContentLeft>

                <S.ContentRight as={link ? 'button' : 'div'} onClick={() => link && routerPush(link)}>
                  <Image
                    alt={image.alt}
                    src={image.url}
                    width={image.width}
                    height={image.height}
                    priority={index <= 1}
                  />
                </S.ContentRight>
              </S.ContentInfos>
            </Col>
          </Row>
        </S.Finishing>
      ))}
    </>
  )
}
